import {AdminRoleId} from "../../Models/Enums/AdminRoleId";

export function IsDev() {
    if (!process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === "development") {

        // development build code
        return true;

    } else {

        // production build code
        return false;
    }
}

export function IsFreeAccount(
    adminRoleId: number | null | undefined,
): boolean {
    return (adminRoleId ?? 0) >= AdminRoleId.FreeAccount;
}
